/* eslint-disable max-len */
import 'react';

const ImportLoadingSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="1em" height="1em" viewBox="0 0 22 22" {...props}>
        <g
            strokeWidth={1.5}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <circle
                cx={11.429}
                cy={11.429}
                r={10}
                stroke="#C7CDD9"
                transform="translate(-.429 -.429)"
            />
            <path
                d="M6.757 12.243L11 8l4.243 4.243"
                stroke="#878D99"
                strokeDasharray="31.4,19"
            />
        </g>
    </svg>
);

export default ImportLoadingSvg;
